"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const shallow_1 = require("zustand/shallow");
const useScrollRestoration_1 = require("../../../../utils/useScrollRestoration");
const zustandStore_1 = require("../../../../zustandStore");
const toggleSetting_1 = __importDefault(require("../../../molecules/setting/toggleSetting"));
const CompanyFeatureToggle = ({ featureKey, label, ui }) => {
    const { setCompanyFeature, company, setIsCompanySettingsSaveBtnDisabled, companyErrors, setCompanyErrors } = (0, zustandStore_1.useZustand)((0, shallow_1.useShallow)(state => ({
        setCompanyFeature: state.setCompanyFeature,
        setCompanyErrors: state.setCompanyErrors,
        setIsCompanySettingsSaveBtnDisabled: state.setIsCompanySettingsSaveBtnDisabled,
        company: state.company,
        companyErrors: state.company.companyErrors,
    })));
    const { restoreScroll } = (0, useScrollRestoration_1.useScrollRestoration)();
    const handleToggle = (0, react_1.useCallback)((event, checked) => {
        restoreScroll();
        const { name } = event.target;
        setCompanyFeature({ key: name, value: checked });
        if (name === 'ENABLE_VIRTUAL_CARD_EXP_RANGE' || (name === 'ENABLE_DOMAIN_WHITELISTING' && !checked)) {
            const errors = lodash_1.default.omit(companyErrors, [name]);
            setCompanyErrors(errors);
            setIsCompanySettingsSaveBtnDisabled(Object.keys(errors).length > 0);
        }
        else {
            setIsCompanySettingsSaveBtnDisabled(Object.keys(companyErrors).length > 0);
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(toggleSetting_1.default, { name: featureKey, label: label, onValueChange: (event, checked) => handleToggle(event, checked), isChecked: Boolean(company?.features?.[featureKey]), style: { width: '100%' } }), ui || null] }));
};
exports.default = CompanyFeatureToggle;
